/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    strong: "strong",
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Pixel"
          }), _jsx(_components.th, {
            children: "Type"
          }), _jsx(_components.th, {
            children: "Rem"
          }), _jsx(_components.th, {
            children: "Custom Property"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "8"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "x-small"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "0.5"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--spacing-x-small"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "16"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "small"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "1"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--spacing-small"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "24"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "medium"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "1.5"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--spacing-medium"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "32"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "2"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--spacing-large"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "48"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "x-large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "3"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--spacing-x-large"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "56"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "xx-large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "3.5"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--spacing-xx-large"
            })
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " In some circumstances you may be in need of using ", _jsx(_components.strong, {
        children: "0.25rem"
      }), " (4px) - therefore ", _jsx(_components.code, {
        children: "xx-small"
      }), " also exists, but as a single type. So, combining ", _jsx(_components.code, {
        children: "xx-small"
      }), " and ", _jsx(_components.code, {
        children: "small"
      }), " would not result in 0.25rem, but still remain 1rem."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
